import { useCallback } from 'react';

const useSetCssVariable = (layoutRef: React.RefObject<HTMLDivElement>) => {
  const setCssVariable = useCallback((name: string, value: string) => {
    if (layoutRef.current) {
      layoutRef.current.style.setProperty(name, value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setHeightCssVariableForRef = useCallback(
    (name: string, ref: React.RefObject<HTMLElement>) => {
      if (ref.current) {
        setCssVariable(name, `${ref.current.offsetHeight || 0}px`);
      }
    },
    [setCssVariable]
  );

  return { setCssVariable, setHeightCssVariableForRef };
};

export default useSetCssVariable;
